<h2 mat-dialog-title translate>dialog.password.error.title</h2>
<mat-divider class="dialog__divider--top"></mat-divider>
<mat-dialog-content>
  <div class="content_dialog">
    <span translate [translateParams]="{ dateToExpired: dateToExpired }">dialog.password.expired.text</span>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button id="acceptButtonPasswordErrorDialog" mat-flat-button color="accent" class="btnMobile" (click)="accept()">
    <span>{{ 'dialog.password.error.accept' | translate | uppercase }}</span>
  </button>
</mat-dialog-actions>
